/**
 * Constants for things used with Hermes websocket handling.
 * Defining constants naming convention should be prefixed with the `key` name
 * followed by two underscores and the `value`. For example, for a hermes
 * message, with `type: 'location'`, the constant name would be`TYPE__LOCATION`.
 * If a field is nested in the message, use single underscores for the JSON
 * path. For example, for message.body.application would be
 * `BODY_APPLICATION__TEXT_FROM_911`
 */

// Types
export const TYPE__LOCATION = 'location';
export const TYPE_SERVER_SENT_EVENT = 'server_sent_event';

export const BODY_APPLICATION__TEXT_FROM_911 = 'text_from_911';
export const BODY_SOURCE__OUTBOUND_SMS = 'outbound_sms';
